const enabled = process.env.NODE_ENV !== "production";

export const warn = (...args) => {
  if (enabled) console.warn(...args);
};
